export default "/icon-settings.svg";